export const blockIconsMapsLocationSearchingNew = (
	<span className='material-symbols-outlined'>location_searching</span>
);
